module.exports = __webpack_public_path__ + "img/dash-location.c270342a.svg";